import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, inr } from "@/lib/api";
import { PageIntro } from "@/components/PageIntro";

export default function Experiences() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/safaris").then((r) => setItems(r.data.filter((s) => s.booking_mode === "on_request"))); }, []);

  return (
    <div className="jt-container py-16" data-testid="experiences-page">
      <PageIntro page="experiences"/>
      {items && items.length === 0 && <p className="text-[#5C6B63]" data-testid="experiences-empty">New experiences coming soon.</p>}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {(items || []).map((s, i) => (
          <Link key={s.id} to={`/safaris/${s.slug}`} data-testid={`experience-card-${s.slug}`} style={{ animationDelay: `${i * 80}ms` }}
            className="group bg-white ring-1 ring-black/5 rounded-2xl overflow-hidden transition-shadow hover:shadow-xl">
            <div className="h-56 overflow-hidden">
              <img src={s.image_url} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transform duration-500"/>
            </div>
            <div className="p-5">
              <h3 className="font-serif text-xl text-[#1C2421]">{s.name}</h3>
              <p className="text-sm text-[#5C6B63] mt-1 mb-3 line-clamp-2">{s.short_description}</p>
              <div className="flex items-center justify-between">
                <span className="font-mono text-sm text-[#1E3A2B]">from {inr(s.base_price)}</span>
                <span className="text-[#C86D51] text-sm">Request →</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
